import * as Yup from 'yup';

const schema = Yup.object().shape({
  reviewNotes: Yup.string()
    .required('Occorre specificare la motivazione del rifiuto'),
});

export default schema;
